import { ITheme } from "../../utils/theme";

export const filterContainerStyle = (theme: ITheme) => ({
  background: theme.palette.blue[900],
  color: theme.palette.common.white,
  p: 2,
});

export const checkBoxStyle = (theme: ITheme) => ({
  color: theme.palette.common.white,
  '&.Mui-checked': {
    color: theme.palette.common.white,
  },
})

export const legendStyle = {
  textDecoration: 'underline',
  float: 'right',
  display: 'flex',
  cursor: 'pointer',
  fontWeight: 'bold',
  '& svg': {
    ml: 1
  },
}

export const legendContentStyle = {
  position: "absolute",
  zIndex: "999",
  top: '40px',
  right: 0,
  width: { xs: '80vw', md: '50%' },
  whiteSpace: 'initial'
}